/* src/app/home/partials/issues-from-drivers/issues-from-drivers.component.scss */
b {
  color: #1e293b;
  font-size: 0.95rem;
}
hr {
  margin: 0.5rem 0 0.75rem;
  border-color: #eef2f6;
}
.issueList {
  list-style: none;
  margin: 0;
  padding: 0;
}
.issueList .issue {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  padding: 0.55rem 0;
  border-top: 1px solid #f1f5f9;
  font-size: 0.85rem;
}
.issueList .issue:first-child {
  border-top: none;
}
.issueList .issue i {
  margin-top: 0.15rem;
  flex: 0 0 auto;
}
.issueList .issue div {
  display: flex;
  flex-direction: column;
}
.issueList .issue strong {
  color: #1e293b;
}
.issueList .issue span {
  color: #64748b;
}
.issueList .issue.high i {
  color: #dc2626;
}
.issueList .issue.medium i {
  color: #f99420;
}
.issueList .issue.low i {
  color: #006498;
}
/*# sourceMappingURL=issues-from-drivers.component.css.map */
